module.exports = __webpack_public_path__ + "img/yellow_pet_happy.5b01263a.svg";